// extracted by mini-css-extract-plugin
var _1 = "ActivityItem-module__activityAvatars--UrAGf";
var _2 = "ActivityItem-module__activityFirstRow--uTjn4";
var _3 = "ActivityItem-module__activityIcon--T6jaa";
var _4 = "ActivityItem-module__activityInner--_5Soc";
var _5 = "ActivityItem-module__activityItem--qTLtN";
var _6 = "ActivityItem-module__activityLinkArrow--AwdDM";
var _7 = "ActivityItem-module__activityNames--TEar7";
var _8 = "ActivityItem-module__activitySecondRow--GvDJg";
var _9 = "ActivityItem-module__activitySeparatorIcon--zTSLP";
var _a = "ActivityItem-module__activitySeparatorText--mdFgj";
var _b = "ActivityItem-module__activityTime--MA3VU";
var _c = "ActivityItem-module__activityVerticalLine--UBjnx";
var _d = "ActivityItem-module__animateUploadProgressBarWidth--bVTHq";
var _e = "ActivityItem-module__animatedBackground--kttaI";
var _f = "ActivityItem-module__hoverIndicator--SWIWp";
var _10 = "ActivityItem-module__isInteractive--jjcQ8";
export { _1 as "activityAvatars", _2 as "activityFirstRow", _3 as "activityIcon", _4 as "activityInner", _5 as "activityItem", _6 as "activityLinkArrow", _7 as "activityNames", _8 as "activitySecondRow", _9 as "activitySeparatorIcon", _a as "activitySeparatorText", _b as "activityTime", _c as "activityVerticalLine", _d as "animateUploadProgressBarWidth", _e as "animatedBackground", _f as "hoverIndicator", _10 as "isInteractive" }
